import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

export default function CroTips() {
    const leftTips = [
        { title: '5 CTA mistakes killing your conversions', desc: 'Vague text, poor contrast, competing elements, wrong placement, and no urgency — fix these and watch clicks rise.' },
        { title: 'Why mobile UX matters more than desktop', desc: 'Over 70% of eCommerce traffic is mobile. If your mobile experience is broken, you are losing the majority of potential buyers.' },
        { title: 'How to reduce landing page friction', desc: 'Remove navigation links, simplify forms, use directional cues, and make your value prop crystal clear above the fold.' },
        { title: 'Why most A/B tests fail', desc: 'Low traffic, testing too many variables, stopping tests early, and no clear hypothesis — avoid these common pitfalls.' },
    ];

    const rightTips = [
        { title: '3 trust elements every product page needs', desc: 'Social proof (reviews), security badges, and a clear return policy — these elements reduce purchase anxiety dramatically.' },
        { title: 'How AI speeds up CRO research', desc: 'Use AI to analyze session recordings at scale, generate hypotheses from analytics data, and write variant copy in minutes.' },
        { title: 'The hidden cost of slow page speed', desc: 'A 1-second delay costs 7% in conversions. Compress images, defer non-critical JS, and use CDNs to stay under 2s LCP.' },
        { title: 'AI-assisted landing page optimization', desc: 'From copy generation to layout analysis — AI tools help you iterate 10× faster while maintaining data-driven decision making.' },
    ];

    return (
        <section className="cro-tips">
            <Container>
                <div className="section-header cro-reveal">
                    <span className="cro-section-label">CRO Knowledge</span>
                    <h2 className="cro-section-title">
                        Quick <span className="highlight">conversion tips</span> you can use today
                    </h2>
                </div>
                <Row>
                    <Col lg={6}>
                        {leftTips.map((tip, idx) => (
                            <div className={`cro-tip-card cro-reveal cro-delay-${idx + 1}`} key={idx}>
                                <div className="tip-number">{idx + 1}</div>
                                <div className="tip-content">
                                    <h4>{tip.title}</h4>
                                    <p>{tip.desc}</p>
                                </div>
                            </div>
                        ))}
                    </Col>
                    <Col lg={6}>
                        {rightTips.map((tip, idx) => (
                            <div className={`cro-tip-card cro-reveal cro-delay-${idx + 1}`} key={idx}>
                                <div className="tip-number">{idx + 5}</div>
                                <div className="tip-content">
                                    <h4>{tip.title}</h4>
                                    <p>{tip.desc}</p>
                                </div>
                            </div>
                        ))}
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

